export default __webpack_public_path__ + "static/media/G1.e00fac0c.mp3";